__turbopack_context__.v({
  "account-background-inset": "bank-module__mL-qbG__account-background-inset",
  "account-background-position": "bank-module__mL-qbG__account-background-position",
  "account-background-rotation": "bank-module__mL-qbG__account-background-rotation",
  "account-background-size": "bank-module__mL-qbG__account-background-size",
  "accountAction": "bank-module__mL-qbG__accountAction",
  "accountActions": "bank-module__mL-qbG__accountActions",
  "accountAddCard": "bank-module__mL-qbG__accountAddCard",
  "accountAmount": "bank-module__mL-qbG__accountAmount",
  "accountBadge": "bank-module__mL-qbG__accountBadge",
  "accountBalanceBlock": "bank-module__mL-qbG__accountBalanceBlock",
  "accountCard": "bank-module__mL-qbG__accountCard",
  "accountCardBadge": "bank-module__mL-qbG__accountCardBadge",
  "accountCardBadges": "bank-module__mL-qbG__accountCardBadges",
  "accountCardLabel": "bank-module__mL-qbG__accountCardLabel",
  "accountCardMiniature": "bank-module__mL-qbG__accountCardMiniature",
  "accountCardMiniatureBlue": "bank-module__mL-qbG__accountCardMiniatureBlue",
  "accountCardMiniatureOrange": "bank-module__mL-qbG__accountCardMiniatureOrange",
  "accountCardMiniaturePurple": "bank-module__mL-qbG__accountCardMiniaturePurple",
  "accountDangerButton": "bank-module__mL-qbG__accountDangerButton",
  "accountDangerRow": "bank-module__mL-qbG__accountDangerRow",
  "accountForeground": "bank-module__mL-qbG__accountForeground",
  "accountGradientBlob": "bank-module__mL-qbG__accountGradientBlob",
  "accountGradientFrame": "bank-module__mL-qbG__accountGradientFrame",
  "accountGradientPosition": "bank-module__mL-qbG__accountGradientPosition",
  "accountGradientRotation": "bank-module__mL-qbG__accountGradientRotation",
  "accountHero": "bank-module__mL-qbG__accountHero",
  "accountHeroContent": "bank-module__mL-qbG__accountHeroContent",
  "accountHistory": "bank-module__mL-qbG__accountHistory",
  "accountLargeBalance": "bank-module__mL-qbG__accountLargeBalance",
  "accountMoreButton": "bank-module__mL-qbG__accountMoreButton",
  "accountName": "bank-module__mL-qbG__accountName",
  "accountOperationBlock": "bank-module__mL-qbG__accountOperationBlock",
  "accountOverview": "bank-module__mL-qbG__accountOverview",
  "accountPageContent": "bank-module__mL-qbG__accountPageContent",
  "accountScreen": "bank-module__mL-qbG__accountScreen",
  "accountScroller": "bank-module__mL-qbG__accountScroller",
  "accountSecondDate": "bank-module__mL-qbG__accountSecondDate",
  "accountSectionBar": "bank-module__mL-qbG__accountSectionBar",
  "accountSectionTitle": "bank-module__mL-qbG__accountSectionTitle",
  "accountSettings": "bank-module__mL-qbG__accountSettings",
  "accountSettingsTitle": "bank-module__mL-qbG__accountSettingsTitle",
  "addProductCard": "bank-module__mL-qbG__addProductCard",
  "addProductLabel": "bank-module__mL-qbG__addProductLabel",
  "avatar": "bank-module__mL-qbG__avatar",
  "backButton": "bank-module__mL-qbG__backButton",
  "backGlass": "bank-module__mL-qbG__backGlass",
  "backGlassContent": "bank-module__mL-qbG__backGlassContent",
  "backGlassPull": "bank-module__mL-qbG__backGlassPull",
  "backSide": "bank-module__mL-qbG__backSide",
  "balance": "bank-module__mL-qbG__balance",
  "balanceArea": "bank-module__mL-qbG__balanceArea",
  "balanceCaption": "bank-module__mL-qbG__balanceCaption",
  "balanceGroup": "bank-module__mL-qbG__balanceGroup",
  "balanceRow": "bank-module__mL-qbG__balanceRow",
  "balanceVisibility": "bank-module__mL-qbG__balanceVisibility",
  "bankHeader": "bank-module__mL-qbG__bankHeader",
  "bankUiRoot": "bank-module__mL-qbG__bankUiRoot",
  "benefitBento": "bank-module__mL-qbG__benefitBento",
  "benefitChip": "bank-module__mL-qbG__benefitChip",
  "benefitChips": "bank-module__mL-qbG__benefitChips",
  "benefitLabel": "bank-module__mL-qbG__benefitLabel",
  "benefitSub": "bank-module__mL-qbG__benefitSub",
  "benefitTile": "bank-module__mL-qbG__benefitTile",
  "benefitTileHit": "bank-module__mL-qbG__benefitTileHit",
  "benefitTileWide": "bank-module__mL-qbG__benefitTileWide",
  "benefitValue": "bank-module__mL-qbG__benefitValue",
  "buttonInset": "bank-module__mL-qbG__buttonInset",
  "cardCarousel": "bank-module__mL-qbG__cardCarousel",
  "cardField": "bank-module__mL-qbG__cardField",
  "cardFieldList": "bank-module__mL-qbG__cardFieldList",
  "cardPill": "bank-module__mL-qbG__cardPill",
  "cardPills": "bank-module__mL-qbG__cardPills",
  "cardRevealButton": "bank-module__mL-qbG__cardRevealButton",
  "cardScreen": "bank-module__mL-qbG__cardScreen",
  "cardSettings": "bank-module__mL-qbG__cardSettings",
  "cardSlide": "bank-module__mL-qbG__cardSlide",
  "cardSlideActive": "bank-module__mL-qbG__cardSlideActive",
  "cardSlideNext": "bank-module__mL-qbG__cardSlideNext",
  "cardSlidePrevious": "bank-module__mL-qbG__cardSlidePrevious",
  "cardTop": "bank-module__mL-qbG__cardTop",
  "cashbackAccent": "bank-module__mL-qbG__cashbackAccent",
  "cashbackBadge": "bank-module__mL-qbG__cashbackBadge",
  "cashbackBentoRow": "bank-module__mL-qbG__cashbackBentoRow",
  "cashbackBentoRowBottom": "bank-module__mL-qbG__cashbackBentoRowBottom",
  "cashbackBentoRowTop": "bank-module__mL-qbG__cashbackBentoRowTop",
  "cashbackCellTitle": "bank-module__mL-qbG__cashbackCellTitle",
  "cashbackConnectedActions": "bank-module__mL-qbG__cashbackConnectedActions",
  "cashbackConnectedHero": "bank-module__mL-qbG__cashbackConnectedHero",
  "cashbackConnectedScreen": "bank-module__mL-qbG__cashbackConnectedScreen",
  "cashbackConnectedStack": "bank-module__mL-qbG__cashbackConnectedStack",
  "cashbackDisconnectedActions": "bank-module__mL-qbG__cashbackDisconnectedActions",
  "cashbackDisconnectedScreen": "bank-module__mL-qbG__cashbackDisconnectedScreen",
  "cashbackPartnerCount": "bank-module__mL-qbG__cashbackPartnerCount",
  "cashbackPartnerLogos": "bank-module__mL-qbG__cashbackPartnerLogos",
  "cashbackScreen": "bank-module__mL-qbG__cashbackScreen",
  "cashbackSuccessSheet": "bank-module__mL-qbG__cashbackSuccessSheet",
  "category-background-position": "bank-module__mL-qbG__category-background-position",
  "categoryActionBar": "bank-module__mL-qbG__categoryActionBar",
  "categoryCta": "bank-module__mL-qbG__categoryCta",
  "categoryDescription": "bank-module__mL-qbG__categoryDescription",
  "categoryFaqButton": "bank-module__mL-qbG__categoryFaqButton",
  "categoryFaqPlaceholder": "bank-module__mL-qbG__categoryFaqPlaceholder",
  "categoryHero": "bank-module__mL-qbG__categoryHero",
  "categoryIcon": "bank-module__mL-qbG__categoryIcon",
  "categoryList": "bank-module__mL-qbG__categoryList",
  "categoryName": "bank-module__mL-qbG__categoryName",
  "categoryRow": "bank-module__mL-qbG__categoryRow",
  "categoryRowWrap": "bank-module__mL-qbG__categoryRowWrap",
  "categoryScreen": "bank-module__mL-qbG__categoryScreen",
  "categorySheet": "bank-module__mL-qbG__categorySheet",
  "categoryTitle": "bank-module__mL-qbG__categoryTitle",
  "censor-bubble-float": "bank-module__mL-qbG__censor-bubble-float",
  "censorBubble": "bank-module__mL-qbG__censorBubble",
  "censorBubbles": "bank-module__mL-qbG__censorBubbles",
  "censorBubblesAccount": "bank-module__mL-qbG__censorBubblesAccount",
  "censorBubblesBalance": "bank-module__mL-qbG__censorBubblesBalance",
  "censorBubblesTransaction": "bank-module__mL-qbG__censorBubblesTransaction",
  "chart": "bank-module__mL-qbG__chart",
  "chartBlock": "bank-module__mL-qbG__chartBlock",
  "chartLabel": "bank-module__mL-qbG__chartLabel",
  "chartLegend": "bank-module__mL-qbG__chartLegend",
  "chartNumbers": "bank-module__mL-qbG__chartNumbers",
  "chartSegment": "bank-module__mL-qbG__chartSegment",
  "chartTop": "bank-module__mL-qbG__chartTop",
  "chartValue": "bank-module__mL-qbG__chartValue",
  "checkbox": "bank-module__mL-qbG__checkbox",
  "checkboxSelected": "bank-module__mL-qbG__checkboxSelected",
  "chevron": "bank-module__mL-qbG__chevron",
  "chevronCollapsed": "bank-module__mL-qbG__chevronCollapsed",
  "chooseButton": "bank-module__mL-qbG__chooseButton",
  "collapsibleRegion": "bank-module__mL-qbG__collapsibleRegion",
  "collapsibleRegionClosed": "bank-module__mL-qbG__collapsibleRegionClosed",
  "collapsibleRegionInner": "bank-module__mL-qbG__collapsibleRegionInner",
  "copiedToast": "bank-module__mL-qbG__copiedToast",
  "copyGlyph": "bank-module__mL-qbG__copyGlyph",
  "currency-values-change": "bank-module__mL-qbG__currency-values-change",
  "currencyCode": "bank-module__mL-qbG__currencyCode",
  "currencyContent": "bank-module__mL-qbG__currencyContent",
  "currencyRow": "bank-module__mL-qbG__currencyRow",
  "currencyRows": "bank-module__mL-qbG__currencyRows",
  "currencySegmentActive": "bank-module__mL-qbG__currencySegmentActive",
  "currencySegments": "bank-module__mL-qbG__currencySegments",
  "currencySurface": "bank-module__mL-qbG__currencySurface",
  "currencyValue": "bank-module__mL-qbG__currencyValue",
  "dangerPill": "bank-module__mL-qbG__dangerPill",
  "dangerRow": "bank-module__mL-qbG__dangerRow",
  "dateHeading": "bank-module__mL-qbG__dateHeading",
  "detailHeaderRow": "bank-module__mL-qbG__detailHeaderRow",
  "detailSubtitle": "bank-module__mL-qbG__detailSubtitle",
  "detailTitle": "bank-module__mL-qbG__detailTitle",
  "detailTitleWrap": "bank-module__mL-qbG__detailTitleWrap",
  "errorMessage": "bank-module__mL-qbG__errorMessage",
  "exchangeButton": "bank-module__mL-qbG__exchangeButton",
  "eyeIcon": "bank-module__mL-qbG__eyeIcon",
  "faqAnswer": "bank-module__mL-qbG__faqAnswer",
  "faqBlock": "bank-module__mL-qbG__faqBlock",
  "faqIcon": "bank-module__mL-qbG__faqIcon",
  "faqList": "bank-module__mL-qbG__faqList",
  "faqRow": "bank-module__mL-qbG__faqRow",
  "field": "bank-module__mL-qbG__field",
  "fieldGrid": "bank-module__mL-qbG__fieldGrid",
  "fieldLabel": "bank-module__mL-qbG__fieldLabel",
  "flipBack": "bank-module__mL-qbG__flipBack",
  "flipBackNight": "bank-module__mL-qbG__flipBackNight",
  "flipBackOrange": "bank-module__mL-qbG__flipBackOrange",
  "flipBadge": "bank-module__mL-qbG__flipBadge",
  "flipCardInner": "bank-module__mL-qbG__flipCardInner",
  "flipCardInnerBack": "bank-module__mL-qbG__flipCardInnerBack",
  "flipCarousel": "bank-module__mL-qbG__flipCarousel",
  "flipEnding": "bank-module__mL-qbG__flipEnding",
  "flipEndingDark": "bank-module__mL-qbG__flipEndingDark",
  "flipFace": "bank-module__mL-qbG__flipFace",
  "flipField": "bank-module__mL-qbG__flipField",
  "flipFieldPair": "bank-module__mL-qbG__flipFieldPair",
  "flipFields": "bank-module__mL-qbG__flipFields",
  "flipFront": "bank-module__mL-qbG__flipFront",
  "flipFrontNight": "bank-module__mL-qbG__flipFrontNight",
  "flipFrontOrange": "bank-module__mL-qbG__flipFrontOrange",
  "flipLogo": "bank-module__mL-qbG__flipLogo",
  "flipMir": "bank-module__mL-qbG__flipMir",
  "form": "bank-module__mL-qbG__form",
  "formMessage": "bank-module__mL-qbG__formMessage",
  "formSurface": "bank-module__mL-qbG__formSurface",
  "fullButton": "bank-module__mL-qbG__fullButton",
  "grabber": "bank-module__mL-qbG__grabber",
  "grabberHit": "bank-module__mL-qbG__grabberHit",
  "heroAction": "bank-module__mL-qbG__heroAction",
  "heroButtons": "bank-module__mL-qbG__heroButtons",
  "historyContent": "bank-module__mL-qbG__historyContent",
  "historyDay": "bank-module__mL-qbG__historyDay",
  "historyList": "bank-module__mL-qbG__historyList",
  "historySurface": "bank-module__mL-qbG__historySurface",
  "homeFlow": "bank-module__mL-qbG__homeFlow",
  "homeScreen": "bank-module__mL-qbG__homeScreen",
  "homeTop": "bank-module__mL-qbG__homeTop",
  "kopecks": "bank-module__mL-qbG__kopecks",
  "largeBalance": "bank-module__mL-qbG__largeBalance",
  "legendDot": "bank-module__mL-qbG__legendDot",
  "maskedNumber": "bank-module__mL-qbG__maskedNumber",
  "merchantIcon": "bank-module__mL-qbG__merchantIcon",
  "merchantImage": "bank-module__mL-qbG__merchantImage",
  "miniSegment": "bank-module__mL-qbG__miniSegment",
  "miniSegmentActive": "bank-module__mL-qbG__miniSegmentActive",
  "miniSegments": "bank-module__mL-qbG__miniSegments",
  "nextCategories": "bank-module__mL-qbG__nextCategories",
  "nextCategoriesBackdrop": "bank-module__mL-qbG__nextCategoriesBackdrop",
  "nextCategoriesConfirmed": "bank-module__mL-qbG__nextCategoriesConfirmed",
  "nextCategoriesConfirmedContent": "bank-module__mL-qbG__nextCategoriesConfirmedContent",
  "nextCategoriesCopy": "bank-module__mL-qbG__nextCategoriesCopy",
  "nextCategoriesDetails": "bank-module__mL-qbG__nextCategoriesDetails",
  "nextCategoriesIconTile": "bank-module__mL-qbG__nextCategoriesIconTile",
  "nextCategoriesIcons": "bank-module__mL-qbG__nextCategoriesIcons",
  "nextCategoriesSummary": "bank-module__mL-qbG__nextCategoriesSummary",
  "nextCategoriesText": "bank-module__mL-qbG__nextCategoriesText",
  "nextCategoriesTitle": "bank-module__mL-qbG__nextCategoriesTitle",
  "pageContent": "bank-module__mL-qbG__pageContent",
  "partnerDot": "bank-module__mL-qbG__partnerDot",
  "partnerDots": "bank-module__mL-qbG__partnerDots",
  "paymentCard": "bank-module__mL-qbG__paymentCard",
  "paymentCardBack": "bank-module__mL-qbG__paymentCardBack",
  "paymentCardFront": "bank-module__mL-qbG__paymentCardFront",
  "peekCard": "bank-module__mL-qbG__peekCard",
  "plainIconButton": "bank-module__mL-qbG__plainIconButton",
  "plus": "bank-module__mL-qbG__plus",
  "points": "bank-module__mL-qbG__points",
  "pointsSub": "bank-module__mL-qbG__pointsSub",
  "primaryButton": "bank-module__mL-qbG__primaryButton",
  "profile": "bank-module__mL-qbG__profile",
  "profileHeader": "bank-module__mL-qbG__profileHeader",
  "promoArtworkCards": "bank-module__mL-qbG__promoArtworkCards",
  "promoArtworkFrame": "bank-module__mL-qbG__promoArtworkFrame",
  "promoArtworkStrong": "bank-module__mL-qbG__promoArtworkStrong",
  "promoBackdrop": "bank-module__mL-qbG__promoBackdrop",
  "promoCard": "bank-module__mL-qbG__promoCard",
  "promoCardClosing": "bank-module__mL-qbG__promoCardClosing",
  "promoCloseHit": "bank-module__mL-qbG__promoCloseHit",
  "promoCopy": "bank-module__mL-qbG__promoCopy",
  "promoImage": "bank-module__mL-qbG__promoImage",
  "promoRegion": "bank-module__mL-qbG__promoRegion",
  "promoRegionEmpty": "bank-module__mL-qbG__promoRegionEmpty",
  "promoRegionInner": "bank-module__mL-qbG__promoRegionInner",
  "promoScroller": "bank-module__mL-qbG__promoScroller",
  "promoText": "bank-module__mL-qbG__promoText",
  "promoTitle": "bank-module__mL-qbG__promoTitle",
  "quickAction": "bank-module__mL-qbG__quickAction",
  "quickActions": "bank-module__mL-qbG__quickActions",
  "quickIcon": "bank-module__mL-qbG__quickIcon",
  "quickIconPrimary": "bank-module__mL-qbG__quickIconPrimary",
  "screen": "bank-module__mL-qbG__screen",
  "screenStack": "bank-module__mL-qbG__screenStack",
  "secondaryButton": "bank-module__mL-qbG__secondaryButton",
  "sectionBar": "bank-module__mL-qbG__sectionBar",
  "sectionHeading": "bank-module__mL-qbG__sectionHeading",
  "sectionPill": "bank-module__mL-qbG__sectionPill",
  "sectionTitleButton": "bank-module__mL-qbG__sectionTitleButton",
  "settingIcon": "bank-module__mL-qbG__settingIcon",
  "settingsArrow": "bank-module__mL-qbG__settingsArrow",
  "settingsLabel": "bank-module__mL-qbG__settingsLabel",
  "settingsList": "bank-module__mL-qbG__settingsList",
  "settingsRow": "bank-module__mL-qbG__settingsRow",
  "settingsRowSimple": "bank-module__mL-qbG__settingsRowSimple",
  "shake": "bank-module__mL-qbG__shake",
  "statusBar": "bank-module__mL-qbG__statusBar",
  "statusIcons": "bank-module__mL-qbG__statusIcons",
  "successCloseButton": "bank-module__mL-qbG__successCloseButton",
  "successImage": "bank-module__mL-qbG__successImage",
  "successMessage": "bank-module__mL-qbG__successMessage",
  "successOverlay": "bank-module__mL-qbG__successOverlay",
  "successOverlayClosing": "bank-module__mL-qbG__successOverlayClosing",
  "successOverlayIn": "bank-module__mL-qbG__successOverlayIn",
  "successOverlayOut": "bank-module__mL-qbG__successOverlayOut",
  "successSheet": "bank-module__mL-qbG__successSheet",
  "successSheetClosing": "bank-module__mL-qbG__successSheetClosing",
  "successSheetDragging": "bank-module__mL-qbG__successSheetDragging",
  "successSheetIn": "bank-module__mL-qbG__successSheetIn",
  "successText": "bank-module__mL-qbG__successText",
  "successTitle": "bank-module__mL-qbG__successTitle",
  "surface": "bank-module__mL-qbG__surface",
  "surfaceCollapsed": "bank-module__mL-qbG__surfaceCollapsed",
  "surfaceFlush": "bank-module__mL-qbG__surfaceFlush",
  "textButton": "bank-module__mL-qbG__textButton",
  "toolbar": "bank-module__mL-qbG__toolbar",
  "toolbarButton": "bank-module__mL-qbG__toolbarButton",
  "toolbarGlass": "bank-module__mL-qbG__toolbarGlass",
  "toolbarGlassPull": "bank-module__mL-qbG__toolbarGlassPull",
  "transaction": "bank-module__mL-qbG__transaction",
  "transactionAmount": "bank-module__mL-qbG__transactionAmount",
  "transactionBonus": "bank-module__mL-qbG__transactionBonus",
  "transactionMain": "bank-module__mL-qbG__transactionMain",
  "transactionMeta": "bank-module__mL-qbG__transactionMeta",
  "transactionTitle": "bank-module__mL-qbG__transactionTitle",
  "trendDown": "bank-module__mL-qbG__trendDown",
  "trendUp": "bank-module__mL-qbG__trendUp",
  "yearBarGrow": "bank-module__mL-qbG__yearBarGrow",
  "yearChart": "bank-module__mL-qbG__yearChart",
  "yearChartBar": "bank-module__mL-qbG__yearChartBar",
  "yearChartBarCurrent": "bank-module__mL-qbG__yearChartBarCurrent",
  "yearChartColumn": "bank-module__mL-qbG__yearChartColumn",
  "yearChartColumns": "bank-module__mL-qbG__yearChartColumns",
  "yearChartMonth": "bank-module__mL-qbG__yearChartMonth",
  "yearChartValue": "bank-module__mL-qbG__yearChartValue",
});
